export const TYPE = [
  {
    _id: 'generic',
    label: 'Generic',
  },
  {
    _id: 'digital-call-deflection',
    label: 'Digital Call Deflection',
  },
  {
    _id: 'campaign',
    label: 'Campaign',
  },
];
